module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/interface/footer-logo-0924ae65f3fcfd9cb8d04f517f99efdc.svg";